// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notifications__list{height:490px;margin:-30px;overflow-x:hidden;overflow-y:auto}.notifications__mark-read{background-color:transparent;border:none;color:#424242;cursor:pointer;font-size:14px;margin-bottom:12px;margin-left:40px;margin-top:35px}.notifications__mark-read:focus{outline:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
